"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
let EditSortNumberSingleDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.id = "";
    this.sortWay = "Increasing";
    this.sortStartNumber = null;
    this.sortNmuber = 0;
  }
  open(id, sort) {
    this.id = id;
    if (sort) {
      this.sortStartNumber = sort;
      this.sortNmuber = sort;
    }
    this._edit_sort_number_single_dialog.show();
  }
  confirm() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth.pro/v1/user_shop_sort/shops/${this.id}/${this.sortNmuber}`);
        this.$message.success(this.$t("edit_sort_number_dialog.success_message"));
        this.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancel() {
    this.close();
  }
  close() {
    this._edit_sort_number_single_dialog.hide();
    this.id = "";
    this.sortStartNumber = null;
    this.sortNmuber = 0;
  }
};
__decorateClass([
  Ref("edit-sort-number-single-dialog")
], EditSortNumberSingleDialog.prototype, "_edit_sort_number_single_dialog", 2);
EditSortNumberSingleDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], EditSortNumberSingleDialog);
export {
  EditSortNumberSingleDialog as default
};
